import $ from 'jquery'
import FlexSlider from 'flexslider'

const opts = {
  jsSelector: '.flexslider',
  flexOpts: {
    animation: 'slide',
    loop: false,
    controlNav: false
  }
}

const init = function() {
  const $flex = $(opts.jsSelector)

  // must be called after events initialization
  $flex.flexslider(opts.flexOpts)
}

$(document).ready(init)

export default { opts, init, FlexSlider }






/** WEBPACK FOOTER **
 ** ./src/modules/flexslider/index.js
 **/